// extracted by mini-css-extract-plugin
module.exports = {"label":"CurrencySelect__label--1fzOb","flag":"CurrencySelect__flag--3lsf0"};